import { render, staticRenderFns } from "./ClientGestationContactLensesCard.vue?vue&type=template&id=4d546d98&"
import script from "./ClientGestationContactLensesCard.vue?vue&type=script&lang=js&"
export * from "./ClientGestationContactLensesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports